<script setup>
import { inject, onMounted, onUnmounted, ref} from 'vue'
import { useDisplay } from 'vuetify'
const { mdAndDown } = useDisplay()
import RepositoryFactory from '@/repositories/RepositoryFactory'

const storeFourUploadBaseUrl = inject('storeFourBaseUrl')
const PromotionBanners = RepositoryFactory.get('PromotionBanners')
const getImageSrc = (image) => {
  return `${storeFourUploadBaseUrl}/filepond/announcement/${image}`
}

const banners = ref([])
const onboarding = ref(0)
const slideGroup = ref(null)
const width = ref(200)

onMounted(async () => {
  try {
    const { data } = await PromotionBanners.get()
    banners.value = data
  } catch (e) {
    console.log(e)
  }

  setTimeout(() => {
      width.value = slideGroup.value.$el.clientWidth / 1.20
  }, 200)
})
const gotToLink = (link)=>{
  window.location.href = link
}
const changeSlideHandler=(state)=>{
  state ==='prev'? onboarding.value-- : onboarding.value++
  onboarding.value > banners.value.length-1 ||  onboarding.value <= 0 ? onboarding.value= 0 : ''
}
const interval = setInterval(() => {
  onboarding.value = (onboarding.value + 1) % banners.value.length
}, 9000)
onUnmounted(() => {
  clearInterval(interval)
})
</script>
<template>
  <v-container tag="section" class="cl__section__margin__bottom">
    <v-row justify="center">

      <v-col cols="12" class="position-relative">
        <div v-if="!$vuetify.display.mobile" @click="changeSlideHandler('prev')" class="position-absolute" style="top: 50%; right: -15px; cursor: pointer">
          <i class="icon-angle-right slider-prev"></i>
        </div>
        <v-slide-group
          v-model="onboarding"
          center-active
          ref="slideGroup"
          mobile-breakpoint="xxl"
          :show-arrows="false"
          mobile
          breakpoint="xl"
        >


          <v-slide-group-item
            v-for="(slide, index) in banners"
            :key="slide"
          >
            <div class="subheader__card ma-4 rounded-xl">
              <v-card
                style="box-shadow: 0px 20px 24px 0px rgba(0, 0, 0, 0.03), 0px 8px 8px 0px rgba(0, 0, 0, 0.03);"
                class="rounded-xl my-6 d-flex "
                :class="[$vuetify.display.mdAndDown ? 'flex-column justify-start' : 'flex-row justify-space-between']"
                :height="$vuetify.display.mobile?'470px':'360px'"
                border
                :width="width"
                @click="gotToLink(slide.link)"
              >
                <img :src="getImageSrc(slide.img_filename)" class="promotion-banner__image" />
                <div
                  :class="[$vuetify.display.mdAndDown ? 'w-100 pa-4 h-100' : 'w-50 pa-8']"
                  class="d-flex flex-column justify-space-between align-center text-right"
                >
                  <div class="d-flex flex-column justify-space-between align-start w-100" >
                    <h2 class="font-weight-bold promotion__banner__title">
                      {{ slide.title }}
                    </h2>
                    <p class="why__slide__content mt-6" v-html="slide.description"></p>
                  </div>
                  <v-btn :href="slide.ext_url" flat elevation="0" color="#155EEF" width="100%" class="rounded-lg text-decoration-none">
                    مشاهده جزئیات
                  </v-btn>
                </div>
              </v-card>
            </div>
          </v-slide-group-item>

        </v-slide-group>
        <template ></template>
        <div @click="changeSlideHandler('next')"  class="position-absolute" style="top: 50%; left: -20px; cursor: pointer">
          <i class="icon-angle-left slider-next"></i>
        </div>

        <div class="dots-slider-container">
          <div
            v-for="(slide, index) in banners"
            :key="'dots-' + index"
            :class="['dots', { active: onboarding === index }]"
            @click="onboarding = index"
          ></div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>



<style scoped lang="scss">
.promotion__banner__title {
  font-size: 48px;
  @include media-breakpoint-down(md) {
    font-size: 24px;
  }
}

.dots-slider-container {
  display: flex;
  justify-content: center;
  margin-top: 16px;
}

.dots {
  width: 12px;
  height: 12px;
  cursor: pointer;
  margin: 0 5px;
  border-radius: 50%;
  background-color: grey;
  transition: width 0.3s, background-color 0.3s;
}

.dots.active {
  width: 55px;
  border-radius: 5px;
  background-color: gray;
}
.promotion-banner__image{
  aspect-ratio: 16/9;
  object-fit: fill;
  width: 50%;
  @include media-breakpoint-down(md){
    width: 100%;
  }
}
</style>

